import React from "react";
import { Table, Button } from "semantic-ui-react";
import { connect } from "react-redux";
import { dispatch } from "@rematch/core";
import LoadingComponent from "../../../common/LoadingComponent";
import { toastr } from "react-redux-toastr";

class OrgUnitReplaceUserSearchTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      setRole: "",
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  componentWillMount() {}

  resendInvitation(invite) {
    invite.organizationId = this.props.organizationId;
    let message = (
      <div className="confirmMessage">
        <h3>Resend Invitation</h3>
        <label>{invite.email}</label>
        <p>Are you sure that you wish to resend this invitation?</p>
      </div>
    );
    toastr.confirm(message, {
      onOk: () => {
        let organizationObj = {
          name: this.props.selectedOrganisation.name,
        };
        let subject =
          this.props.teamDropdownDisableFlag &&
          this.props.selectedSubOrg &&
          this.props.selectedSubOrg.name
            ? `You have been Invited to join the "${this.props.selectedSubOrg.name}" Team for "${this.props.selectedOrganisation.name}" Workspace on Aspenify platform.`
            : `You have been Invited to join the "${this.props.selectedOrganisation.name}" Workspace on Aspenify platform.`;
        let emailObject = {
          templateName: "resendInviteMail",
          toEmail: invite.email,
          invite: invite,
          invitationCode: invite._id,
          fromUser: this.props.user,
          organization: organizationObj,
          subject: subject,
        };
        dispatch.invite.resendInvitation(emailObject);
      },
    });
  }
  deleteInvitaion(userdata) {
    userdata.organizationId = this.props.organizationId;
    let message = (
      <div className="confirmMessage">
          <h3>Delete Invitation</h3>
          <label>{userdata.firstName} {userdata.lastName}</label>
        <p>Are you sure that you wish to delete this invitation?</p>
        <span>This action is not reversible</span>
      </div>
    );
    toastr.confirm(message, {
      onOk: () => {
        dispatch.invite.deleteInvitaionAsync(userdata);
        if (
          this.props.stringType === "TeamMapping" ||
          this.props.stringType === "SubOrgUserAddModal"
        ) {
          this.props.onClose();
        } else {
          this.props.handleReset();
        }
      },
    });
  }
  async addUserInSubUnit(userData) {
    // let formData = {}
    // let teamId = this.props.selectedSubOrg._id;
    // formData.accountId = this.props.match.params.accountId;
    // formData.organizationId = this.props.match.params.workspaceId;
    // formData.teamId = teamId;
    // formData.from = this.props.user._id;
    // formData.accountUserId = userData._id;
    // formData.role = this.state.setRole;
    // formData.parentOrganizationId = this.props.selectedSubOrg.parentOrganizationId;
    // formData.stringType = this.props.stringType;
    // formData.organizationName = this.props.selectedOrganisation.name;

    let message = (
      <div className="confirmMessage">
        <h3>Replace User</h3>
        <label>
          {userData.firstName} {userData.lastName}
        </label>
        <p>Are you sure that you wish to Replace {this.props.userObj.firstName + ' ' + this.props.userObj.lastName} with {userData.firstName} {userData.lastName}?</p>
      </div>
    );
    toastr.confirm(message, {
      onOk: async () => {
        console.log("formData", userData._id);
        console.log("this.props",this.props);
        const payload = {
            userId : this.props.userObj._id,
            organizationId: this.props.selectedOrganisation._id,
            accountId : this.props.selectedAccount._id,
            replaceUserId: userData._id,
        }
        await dispatch.users.replaceDeactivateUserFromOrgAsync(payload);
        dispatch.users.userDeactivateModal(false); 
      },
    });
  }

  handleSelect(data) {
    this.setState({ setRole: data.target.value });
  }

  render() {
    return (
      <div>
        <LoadingComponent
          active={this.props.addUserInSubUnitLoader}
          message="Adding User"
        />
        {this.props.searchUserArr && this.props.searchUserArr.length > 0 ? (
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={3}>First Name</Table.HeaderCell>
                <Table.HeaderCell width={3}>Last Name</Table.HeaderCell>
                <Table.HeaderCell width={6}>E-mail</Table.HeaderCell>
                <Table.HeaderCell width={2}>Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {this.props.searchUserArr &&
                this.props.searchUserArr.length > 0 &&
                this.props.searchUserArr.map(function (user, index) {
                  return (
                    <Table.Row key={index}>
                      <Table.Cell>{user.firstName}</Table.Cell>
                      <Table.Cell>{user.lastName}</Table.Cell>
                      <Table.Cell>{user.email}</Table.Cell>
                      <Table.Cell>
                        <div>
                          <Button
                            icon="plus"
                            color="green"
                            size="mini"
                            onClick={() => {
                              this.addUserInSubUnit(user);
                            }}
                          />
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  );
                }, this)}
            </Table.Body>
          </Table>
        ) : (
          ""
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    inviteObj: state.invite.inviteObj,
    user: state.app.user,
    selectedOrganisation: state.app.selectedOrganisation,
    userObj: state.users.userObj,
  };
}
const connectedLoginPage = connect(mapStateToProps)(
  OrgUnitReplaceUserSearchTable
);
export default connectedLoginPage;
